module.exports = __webpack_public_path__ + "static/media/classSchedule.e2ba1f9d.svg";